import type { SofiaActionKind } from "../model/constants"
import type { CoviActionItem } from "../model/types"
import {
  isAutoExecute,
  isDestructive,
  isModify,
  isServerExecuted,
} from "./actionGates"
import { parseMetricCreateArgs } from "./metricCreateActionArgs"

// Only independent, already-resolved server proposals may share one approval.
const GROUP_CONFIRMATION_LABELS: Partial<Record<SofiaActionKind, string>> = {
  create_metric: "Create all metrics",
  create_python_metric_draft: "Create all drafts",
  preview_python_metric: "Test all",
  publish_python_metric: "Create all metrics",
  save_python_analysis_metric: "Create all metrics",
  create_persona: "Create all personas",
  create_agent: "Create all agents",
  create_test_set: "Create all test sets",
  create_dashboard: "Create all dashboards",
  create_report: "Create all reports",
  create_widget: "Create all widgets",
  create_review_project: "Create all review projects",
  duplicate_persona: "Duplicate all personas",
  duplicate_agent: "Duplicate all agents",
  duplicate_test_set: "Duplicate all test sets",
}

type ActionStackPolicy =
  | { confirmation: "all"; label: string }
  | { confirmation: "individual" }

export function getActionStackPolicy(kind: SofiaActionKind): ActionStackPolicy {
  const label = GROUP_CONFIRMATION_LABELS[kind]
  if (
    label &&
    isServerExecuted(kind) &&
    !isDestructive(kind) &&
    !isModify(kind)
  ) {
    return { confirmation: "all", label }
  }
  return { confirmation: "individual" }
}

export function isStackableAction(item: CoviActionItem): boolean {
  return !item.provisional && !isAutoExecute(item.proposal.kind)
}

export function canConfirmStackAction(
  item: CoviActionItem,
  now: number,
): boolean {
  return (
    isStackableAction(item) &&
    getActionStackPolicy(item.proposal.kind).confirmation === "all" &&
    item.status === "proposed" &&
    (item.proposal.kind !== "create_metric" ||
      parseMetricCreateArgs(item.proposal).ok) &&
    !!item.proposal.action_id &&
    typeof item.proposal.expires_at === "number" &&
    item.proposal.expires_at * 1000 > now
  )
}
